import React from "react";
import { Row, Col } from "reactstrap";
import { connect } from "react-redux";
import { getSocialMedia } from "../../redux/actions/api/apiAction";
import { Link } from "react-router-dom";
import { Formik, Field, Form, FieldArray, setNestedObjectValues } from "formik";
import * as Yup from "yup";
import { store } from "../../redux/storeConfig/store";
import Button from "../buttons/primaryButton";
import { withNamespaces } from "react-i18next";
import moment from "moment";

class Footer extends React.Component {
  state = {
    // instagram: '',
    facebook: "",
    twitter: "",
    // linkedin: '',
    // id: '',
  };

  componentDidMount = async () => {
    // var user = JSON.parse(localStorage.getItem('user'));
    // console.log("user", user.id)
    // const {match:{params}}=th(is.props;
    //const {match:{params}}=this.props;
    await store.dispatch(getSocialMedia());
    //  this.setState({
    //    facebook: socialMedia.facebook,
    //    twitter: socialMedia.twitter,
    //  // image: user.image,
    // });
    //console.log("socialmedia", getSocialMedia)
    // this.setState({
    //   name: user.name,
    //   userName: user.email,
    //   image: user.image,
    // });
  };
  render() {
    // var user = JSON.parse(localStorage.getItem('user'));
    //console.log("user", this.props.admin.user)
    // this.setState({
    //   instagram: user.instagram,
    //   facebook: user.facebook,
    //   twitter: user.twitter,
    //   linkedin: user.linkedin,
    //   id: user.id
    // });
    // const facebookClick = (values) => {
    //   values.facebook
    // }
    // var socialMedia = this.state.socialMedia;
    // console.log("sm", socialMedia)
    let facebook = this.props.socialMedia.id
      ? this.props.socialMedia.socialMedia.facebook
      : "";
    let instagram = this.props.socialMedia.id
      ? this.props.socialMedia.socialMedia.instagram
      : "";
    let twitter = this.props.socialMedia.id
      ? this.props.socialMedia.socialMedia.twitter
      : "";
    let linkedin = this.props.socialMedia.id
      ? this.props.socialMedia.socialMedia.linkedin
      : "";

    // console.log("fb", this.props.socialMedia);
    return (
      <React.Fragment>
        {/* <Formik
           initialValues={{
            instagram: user.socialMedia ? user.socialMedia.instagram : '',
            facebook: user.socialMedia ? user.socialMedia.facebook : '',
            twitter: user.socialMedia ? user.socialMedia.twitter : '',
            linkedin: user.socialMedia ? user.socialMedia.linkedin : '',
            id: user.id,
          }}
      >
        {({
                errors,
                touched,
                handleChange,
                handleBlur,
                values,
                setFieldValue,
              }) => {
                return ( */}
        <div className="footer">
          <div className="footer-first-block px-0 ">
            <div className="custom-container">
              <div className="d-flex align-items-center">
                <div className="footer-first-list">
                  <ul className="list-block">
                  <li className="list-block-element">
                      <p>{this.props.t("verified_by")}</p>
                    </li>
                    <li className="list-block-element">
                      <img
                        src={require("../../assets/images/master-card.svg")}
                        className="img-fluid"
                        alt="master"
                      />
                    </li>
                    <li className="list-block-element">
                      <img
                        src={require("../../assets/images/visa.svg")}
                        className="img-fluid"
                        alt="visa"
                      />
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div className="footer-main-block">
            <div className="custom-container">
              <Row>
                <Col md={12}>
                  <Link className="footer-logo">
                    <img
                      src={require("../../assets/images/footer-logo.svg")}
                      className="img-fluid footer-logo-image"
                    />
                  </Link>
                </Col>
              </Row>
              <Row className="mt-3">
                <Col md={3}>
                  <div className="support-link-block">
                    <div className="support-title">
                      <h5 className="f-500">{this.props.t("support")}</h5>
                      <div className="phone-support">
                        <Link className="ctf-tx-secondary h5 f-600" dir="ltr">
                          +962 79 1000 446
                        </Link>
                      </div>
                      <div className="mail-support h5 f-600 pt-1 pb-3 pt-md-3 pb-md-1">
                        <Link className="ctf-tx-secondary">
                          team@connecttofit.com
                        </Link>
                      </div>
                    </div>
                  </div>
                </Col>
                <Col md={3}>
                  <div className="pages-link-block">
                    <ul className="pages-link-list-block">
                      <li className="element">
                        <Link to={"/privacy"}>{this.props.t("privacy-policy")}</Link>
                      </li>
                     
                      <li className="element">
                        <Link to={"/terms"}>{this.props.t("term-of-use")}</Link>
                      </li>
                      <li className="element">
                        <Link to={"/enterprise"}>
                          {this.props.t("contact-us")}
                        </Link>
                      </li>
                      {/* <li className="element">
                        <Link>{this.props.t("join-us")}</Link>
                      </li> */}
                    </ul>
                  </div>
                </Col>
                {/* <Col md={6}>
                  <div className="app-link-block">
                    <div className="app-title">
                      <h5 className="f-700 h1">{this.props.t("get-the-app")} !</h5>
                    </div>
                    <div className="app-link-wrapper">
                      <div className="app-list">
                        <button className="btn btn-dark mr-3">
                          <img
                            src={require("../../assets/images/google-play.png")}
                            className="img-fluid"
                          />
                        </button>
                        <button className="btn btn-dark">
                          <img
                            src={require("../../assets/images/ios.png")}
                            className="img-fluid"
                          />
                        </button>
                      </div>
                    </div>
                  </div>
                </Col> */}
              </Row>
            </div>
          </div>
          <div className="copy-right-block py-3 ctf-bg-sixth">
            <div className="custom-container">
              <Row className="align-items-center">
                <Col md={6} className="text-md-left text-center">
                  <h5 className="mb-0">
                    Connecttofit.com © {moment().format("YYYY")}{" "}
                    {this.props.t("all-rights-reserved")}
                  </h5>
                </Col>
                <Col md={6} className="text-md-right text-center">
                  {/* {this.props.socialMedia && this.props.socialMedia.map((value) => {
                    console.log("gyms props", this.props.socialMedia);

                    return (  */}
                  <div className="social-media">
                    <ul className="social-media-list">
                      <li className="social-icons facebook">
                        <a href={facebook} target="_blank">
                          {/* <img
                            src={require("../../assets/images/facebook.svg")}
                            className="img-fluid"
                          /> */}
                        </a>
                      </li>
                      <li className="social-icons facebook">
                        {/* <Link>
                   
                      <img src={require('../../assets/images/instagram.svg')} className="img-fluid" href={values.instagram}/>
                    </Link> */}
                        <a href={instagram} target="_blank">
                          <img
                            src={require("../../assets/images/instagram.svg")}
                            className="img-fluid"
                            href="#"
                          />
                        </a>
                      </li>
                      <li className="social-icons facebook">
                        <a href={twitter} target="_blank">
                          <img
                            src={require("../../assets/images/twitter.svg")}
                            className="img-fluid"
                          />
                        </a>
                      </li>
                      <li className="social-icons facebook">
                        <a href={linkedin} target="_blank">
                          {/* <img
                            src={require("../../assets/images/linkedin.svg")}
                            className="img-fluid"
                          /> */}
                        </a>
                      </li>
                    </ul>
                  </div>
                  {/* )})}  */}
                </Col>
              </Row>
            </div>
          </div>
        </div>
        {/* )  
          }}
   </Formik>{' '} */}
      </React.Fragment>
    );
  }
}
const mapStateToProps = (state) => {
  const { socialMedia } = state.socialMedia;
  // const { selectAll, selection } = state.select.gyms;
  // console.log(state.socialMedia);
  return { socialMedia };
};
// export default Footer;
export default connect(mapStateToProps, {})(withNamespaces()(Footer));
